export default "<app-header></app-header>\n<div class=\"pt54 main\">\n    <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n";